// import { LuminousGallery } from 'luminous-lightbox';
import Glightbox from 'glightbox';

export default new class Lightbox {
  constructor() {
    this.classLightbox = '.list-item__link';

    this.mediaQueryList = window.matchMedia('(min-width: 769px)');

    this.options = {
      touchNavigation: true,
      loop: true,
    };

    this.init();
  }

  isDesktop() {
    return this.mediaQueryList.matches;
  }

  init() {
    const lightbox = new Glightbox(this.options);

    // eslint-disable-next-line no-console
    console.log(lightbox);
  }
}();
